<template>
    <div class="pb-carousel-item mr-3">
        <slot></slot>
    </div>
</template>
<script>


    export default {
        name: "carousel-item",
        data() {
            return {

            }
        },
        mounted: function() {

        },
        methods: {
            close() {

            },
        },

    }
</script>
<style lang="scss" scoped>
    @import "~@shared/_assets/scss/constants";

    .pb-carousel-item {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: auto;
        display: flex;
        justify-content: left;
        align-items: flex-start;

    }

</style>